// extracted by mini-css-extract-plugin
export default {"cycle":"Cycle_cycle__8Udwb","header":"Cycle_header__yDghV"};